<!-- Button -->
<button mat-icon-button [matMenuTriggerFor]="userActions" (menuOpened)="onMenuOpened()">
  <span class="relative">
    <img class="w-7 h-7 rounded-full" *ngIf="showAvatar && user?.avatar" [src]="user.avatar" />
    @if (!showAvatar || !user?.avatar) {
      <mat-icon [svgIcon]="'heroicons_outline:user-circle'"> </mat-icon>
    }
    @if (user) {
      <span
        class="absolute right-0 bottom-0 w-2 h-2 rounded-full"
        [ngClass]="{
          'mr-px mb-px': !showAvatar || !user?.avatar,
          'bg-green-500': user?.status === 'online',
          'bg-amber-500': user?.status === 'away',
          'bg-red-500': user?.status === 'busy',
          'bg-gray-400': user?.status === 'not-visible'
        }"
      ></span>
    }
  </span>
</button>

<mat-menu [xPosition]="'before'" #userActions="matMenu" class="profile-switcher-menu">
  @if (user) {
    <div class="profile-header">
      <div class="profile-avatar">
        <span class="avatar-initials">{{ user.name?.charAt(0)?.toUpperCase() }}</span>
      </div>
      <div class="profile-info">
        <span class="profile-name">{{ user.name }}</span>
        <span class="profile-email">{{ user.email }}</span>
      </div>
    </div>
  }

  <mat-divider></mat-divider>

  @if (isLoading) {
    <div class="loading-container">
      <mat-spinner diameter="24"></mat-spinner>
    </div>
  } @else {
    @for (group of profilesGrouped; track group.account.name) {
      <div class="account-header">
        <span class="account-name">{{ group.account.name }}</span>
      </div>

      @for (profile of group.profiles; track profile.subAccountName) {
        <button
          mat-menu-item
          class="profile-item"
          [class.active]="profile.isActive"
          (click)="selectProfile(profile, $event)"
        >
          <span class="profile-item-content">
            <span class="profile-subaccount-name">{{ profile.subAccountName }}</span>
            @if (profile.isActive) {
              <mat-icon class="check-icon" [svgIcon]="'heroicons_outline:check'"> </mat-icon>
            }
          </span>
        </button>
      }
    }
  }

  <mat-divider class="my-2"></mat-divider>

  <!-- Actions -->
  <button mat-menu-item (click)="changePassword()">
    <mat-icon [svgIcon]="'heroicons_outline:arrow-path'"></mat-icon>
    <span>{{ 'user.changePassword' | translate }}</span>
  </button>
  <button mat-menu-item (click)="signOut()">
    <mat-icon [svgIcon]="'heroicons_outline:arrow-right-on-rectangle'"></mat-icon>
    <span>{{ 'user.signOut' | translate }}</span>
  </button>
</mat-menu>
